import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { Logger } from '@vue-storefront/core/lib/logger'

export const BlogModule: StorefrontModule = function ({ store, router }) {
  Logger.info('Initializing Blog Module')
}
